import MapContainer from '../../../map/website/MapContainer';
import EventMap from '../../../map/website/Map';
import { Button } from '@minted/fancyclothes';
import React, {
  memo,
  useCallback, useMemo, useState,
} from 'react';
import config from 'config';
import { WebsiteEvent } from '../../../resources/modelTypes';
import { formatAddress } from '../../../events/utils';
import { SelectedRecord } from '../../../resources/selectors';
import { connect, useDispatch } from 'react-redux';
import { focusLocation } from '../../../events/actions';

const googleMapsApiKey = config.get('googleMapsApiKey');

const noOp = () => null;

export type DisplayMapProps = {
  events: SelectedRecord<WebsiteEvent>[],
}

type DisplayMapPropsWithRedux = {
  focusedLocationIndex: number | null,
} & DisplayMapProps;

const DisplayMap = ({
  events,
  focusedLocationIndex,
}: DisplayMapPropsWithRedux) => {
  const dispatch = useDispatch();
  const [
    showMap,
    setShowMap,
  ] = useState(false);
  const [
    isMapExpanded,
    setIsMapExtended,
  ] = useState(false);
  const toggleShowMap = useCallback(() => {
    setShowMap((prevVal) => !prevVal);
  }, []);
  const toggleIsMapExpanded = useCallback(() => {
    setIsMapExtended((prevVal) => !prevVal);
  }, []);

  const locations: (WebsiteEvent & {formattedAddress: string})[] = useMemo(() => events.map((event: SelectedRecord<WebsiteEvent>) => ({
    ...event.data,
    formattedAddress: event.data.hasPhysicalAddress
      ? formatAddress(event.data)
      : '',
  })), [
    events,
  ]);

  return (
    showMap
      ? (
        <MapContainer
          isExpanded={isMapExpanded}
          onExpandToggle={toggleIsMapExpanded}
        >
          <EventMap
            apiKey={googleMapsApiKey}
            focusedLocationIndex={focusedLocationIndex}
            focusLocation={(index: number) => dispatch(focusLocation(index))}
            locations={locations}
            onLocationsGeocoded={noOp}
          />
        </MapContainer>
      )
      : (
        <div>
          <Button
            onClick={toggleShowMap}
            text="Show Map"
          />
        </div>
      )
  );
};

const mapStateToProps = (state) => {
  const {
    focusedLocationIndex,
  } = state.events;

  return {
    focusedLocationIndex,
  };
};

// @ts-expect-error Force types for redux/react connection
const ConnectedDisplayMap = connect(mapStateToProps)(DisplayMap) as React.FC<DisplayMapProps>;

const MemoizedDisplayMap = memo(ConnectedDisplayMap);

export { MemoizedDisplayMap as DisplayMap };
